import {iFrameState} from "../services/IFrameState";
import {PANEL_TYPE, POPUP_GATE_TRANSITION_TIME} from "../../blink-sdk/Constants";
import {donateMobileState} from "./inline-donation/DonateMobileState";
import {subscribeFlowState} from "./inline-subscription/SubscribeFlowState";
import {giftSubscriptionFlowState} from "./inline-subscription/GiftSubscriptionFlowState";
import {iFrameConnection} from "../services/IFrameConnection";
import {IFrameMessages} from "../../blink-sdk/messaging/IFrameMessages";


export function initializeFlows() {
    let panelType = null;
    let activeFlow = null;
    let clearTimeoutId = null;

    const clearActiveFlow = () => {
        if (activeFlow) {
            activeFlow.clear();
        }
        panelType = null;
        activeFlow = null;
        clearTimeout(clearTimeoutId);
        clearTimeoutId = null;
    }
    const clearActiveFlowDelayed = () => {
        clearTimeoutId = setTimeout(clearActiveFlow, POPUP_GATE_TRANSITION_TIME)
    }
    const updateActiveFlow = iframeParams => {
        if (!iframeParams.type || panelType === iframeParams.type) {
            return;
        }

        let newActiveFlow = null;
        let newPanelType = iframeParams.type;
        // This needs to be done here too because first route change isn't dispatched.
        if (newPanelType === PANEL_TYPE.empty) {
            clearActiveFlowDelayed();
            return;
        }
        if (clearTimeoutId) {
            clearActiveFlow();
        }
        if (newPanelType === PANEL_TYPE.donation) {
            newActiveFlow = donateMobileState;
        } else if (newPanelType === PANEL_TYPE.subscribe) {
            newActiveFlow = subscribeFlowState;
        } else if (newPanelType === PANEL_TYPE.giftSubscription) {
            newActiveFlow = giftSubscriptionFlowState;
        }
        panelType = newPanelType;
        if (newActiveFlow) {
            activeFlow = newActiveFlow;
            activeFlow.init();
        }
    }
    iFrameState.addUpdateListener(updateActiveFlow);
    updateActiveFlow(iFrameState.iframeParams);

    iFrameConnection.addListener(IFrameMessages.ROUTE_CHANGE, ({url}) => {
        if (url === PANEL_TYPE.empty) {
            clearActiveFlowDelayed();
        }
    });
}
